"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEATURE_GATES_BUILT_FILE_NAME = exports.getFeatures = exports.getGatedFeatNameEnum = exports.GatedFeatName = void 0;
const remoteWorkAmbientDeskTemplateSpaces_1 = require("gather-common/dist/src/public/resources/remoteWorkAmbientDeskTemplateSpaces");
var GatedFeatName;
(function (GatedFeatName) {
    GatedFeatName["SpaceAATest1"] = "SpaceAATest1";
    GatedFeatName["SpaceAATest2"] = "SpaceAATest2";
    GatedFeatName["SpaceAATest3"] = "SpaceAATest3";
    GatedFeatName["UserAATest1"] = "UserAATest1";
    GatedFeatName["UserAATest2"] = "UserAATest2";
    GatedFeatName["UserAATest3"] = "UserAATest3";
    GatedFeatName["LeakyPrivateSpace"] = "LeakyPrivateSpace";
    GatedFeatName["LeakyDeskUI"] = "LeakyDeskUI";
    GatedFeatName["LeakyDeskUIPhysics"] = "LeakyDeskUIPhysics";
    GatedFeatName["LeakyDeskListeningRangeUI"] = "LeakyDeskListeningRangeUI";
    GatedFeatName["LeakyDeskListeningRangeUINoVideos"] = "LeakyDeskListeningRangeUINoVideos";
    GatedFeatName["LeakyDeskFocusOverBusy"] = "LeakyDeskFocusOverBusy";
    GatedFeatName["LeakyDeskBackgroundSFX"] = "LeakyDeskBackgroundSFX";
    GatedFeatName["LeakyDeskPods_DEPRECATED"] = "LeakyDeskPods_DEPRECATED";
    GatedFeatName["LeakyDeskPodsExpanded"] = "LeakyDeskPodsExpanded";
    GatedFeatName["LeakyDeskOpenCoworking"] = "LeakyDeskOpenCoworking";
    GatedFeatName["LeakyDeskDeskPods"] = "LeakyDeskDeskPods";
    GatedFeatName["LeakyDeskSideConversations"] = "LeakyDeskSideConversations";
    GatedFeatName["LeakyDeskAmbientVolumeSlider"] = "LeakyDeskAmbientVolumeSlider";
    GatedFeatName["LeakyDeskAmbientFeedbackModal"] = "LeakyDeskAmbientFeedbackModal";
    GatedFeatName["CenteredNavBar"] = "CenteredNavBar";
    GatedFeatName["InventoryV2"] = "InventoryV2";
    GatedFeatName["GardenTown"] = "GardenTown";
    GatedFeatName["RemoteLogsEnabled"] = "RemoteLogsEnabled";
    GatedFeatName["WallsAndFloors"] = "WallsAndFloors";
    GatedFeatName["ScreenRecording"] = "ScreenRecording";
    GatedFeatName["GatherAvHoldout"] = "GatherAvHoldout";
    GatedFeatName["EnableWebGL2"] = "EnableWebGL2";
    GatedFeatName["AcceleratedStartup2"] = "AcceleratedStartup2";
    GatedFeatName["DesktopPreviewReleases"] = "DesktopPreviewReleases";
    GatedFeatName["TestABTestingAndMetricsUser"] = "TestABTestingAndMetricsUser";
    GatedFeatName["TestABTestingAndMetricsSpace"] = "TestABTestingAndMetricsSpace";
    GatedFeatName["ShowGameClientStatus"] = "ShowGameClientStatus";
    GatedFeatName["ScreenShareBorderMac"] = "ScreenShareBorderMac";
    GatedFeatName["ScreenShareBorderWin"] = "ScreenShareBorderWin";
    GatedFeatName["FetchProcessNames"] = "FetchProcessNames";
    GatedFeatName["Bunnies"] = "Bunnies";
    GatedFeatName["DynamicLocalVideoQuality"] = "DynamicLocalVideoQuality";
    GatedFeatName["ScreenshareLowerResolution"] = "ScreenshareLowerResolution";
    GatedFeatName["SSOAuthentication"] = "SSOAuthentication";
    GatedFeatName["DevicePixelRatioForAdaptiveStream"] = "DevicePixelRatioForAdaptiveStream";
    GatedFeatName["MobilePushNotifications"] = "MobilePushNotifications";
    GatedFeatName["ReloadSfuOnDoubleConnect"] = "ReloadSfuOnDoubleConnect";
    GatedFeatName["UpscaledGather"] = "UpscaledGather";
    GatedFeatName["PerfSurvey"] = "PerfSurvey";
    GatedFeatName["PresentStatus"] = "PresentStatus";
    GatedFeatName["NewTextTool"] = "NewTextTool";
    GatedFeatName["PortalsImprovements"] = "PortalsImprovements";
    GatedFeatName["PromoteToMember"] = "PromoteToMember";
    GatedFeatName["AudioRevokeObjectUrl"] = "AudioRevokeObjectUrl";
    GatedFeatName["DesktopRendererANRDetection"] = "DesktopRendererANRDetection";
    GatedFeatName["DesktopThrottleUpdateCheckWhenOffline"] = "DesktopThrottleUpdateCheckWhenOffline";
    GatedFeatName["OrganicDesktopAutoUpdates"] = "OrganicDesktopAutoUpdates";
    GatedFeatName["DesktopUseGETForUpdateCheck"] = "DesktopUseGETForUpdateCheck";
    GatedFeatName["NewVirtualBgImages"] = "NewVirtualBgImages";
    GatedFeatName["GatherStudio"] = "GatherStudio";
    GatedFeatName["ShowGatherLabsNewChatFeature"] = "ShowGatherLabsNewChatFeature";
    GatedFeatName["UseElectronForRecordingDownloads"] = "UseElectronForRecordingDownloads";
    GatedFeatName["HideSelfView"] = "HideSelfView";
    GatedFeatName["DesktopAutoRestart"] = "DesktopAutoRestart";
    GatedFeatName["WhatsNewNotification"] = "WhatsNewNotification";
    GatedFeatName["SendbirdVerboseLogLevel"] = "SendbirdVerboseLogLevel";
    GatedFeatName["ParticipantsPanelV2"] = "ParticipantsPanelV2";
    GatedFeatName["MobileVideoSubscriptions"] = "MobileVideoSubscriptions";
    GatedFeatName["ScreenShareZoom"] = "ScreenShareZoom";
    GatedFeatName["PaymentsAnnualPlan"] = "PaymentsAnnualPlan";
    GatedFeatName["NoisyEnvironmentDetection"] = "NoisyEnvironmentDetection";
    GatedFeatName["Insights"] = "Insights";
    GatedFeatName["MiniModeNavBarButton"] = "MiniModeNavBarButton";
    GatedFeatName["ChooseSfuByScoring"] = "ChooseSfuByScoring";
    GatedFeatName["MiniModeV2"] = "MiniModeV2";
    GatedFeatName["LocateButtonOnParticipantsPanel"] = "LocateButtonOnParticipantsPanel";
    GatedFeatName["DesktopCliDisableCalulateNativeWinOcclusion"] = "DesktopCliDisableCalculateNativeWinOcclusion";
    GatedFeatName["DesktopCliUseMultiPlaneFormatForSoftwareVideo"] = "DesktopCliUseMultiPlaneFormatForSoftwareVideo";
    GatedFeatName["DesktopCliEnableScreenCaptureKitMac13"] = "DesktopCliEnableScreenCaptureKitMac13";
    GatedFeatName["DesktopCliEnableScreenCaptureKitMac14"] = "DesktopCliEnableScreenCaptureKitMac14";
    GatedFeatName["DesktopCliEnableAllowWgcScreenCapturer"] = "DesktopCliEnableAllowWgcScreenCapturer";
    GatedFeatName["DesktopCliEnableAllowWgcWindowCapturer"] = "DesktopCliEnableAllowWgcWindowCapturer";
    GatedFeatName["EnhancedBNRUseBVC"] = "EnhancedBNRUseBVC";
    GatedFeatName["DesktopAutoUpdateFromDownloadsGatherTown"] = "DesktopAutoUpdateFromDownloadsGatherTown";
    GatedFeatName["LiveCursors"] = "LiveCursors";
    GatedFeatName["ReportUnexpectedActiveSpeaking"] = "ReportUnexpectedActiveSpeaking";
    GatedFeatName["VideoServerStats"] = "VideoServerStats";
    GatedFeatName["NewPricingModel"] = "NewPricingModel";
    GatedFeatName["DesktopDisableWindowTransitionFix"] = "DesktopDisableWindowTransitionFix";
    GatedFeatName["VirtualBackgroundsNoConcurrencyCheck"] = "VirtualBackgroundsNoConcurrencyCheck";
    GatedFeatName["PauseMoveControllerDuringSwitchMap"] = "PauseMoveControllerDuringSwitchMap";
    GatedFeatName["DesktopUseHigherResIconsForScreenShareModal"] = "DesktopUseHigherResIconsForScreenShareModal";
    GatedFeatName["NewMeetingUX"] = "NewMeetingUX";
    GatedFeatName["NoVideoAnimations"] = "NoVideoAnimations";
    GatedFeatName["NoVideoAnimationsAllHardware"] = "NoVideoAnimationsAllHardware";
    GatedFeatName["PlayerShimmy"] = "PlayerShimmy";
    GatedFeatName["DesktopFailedUpdateNotification"] = "DesktopFailedUpdateNotification";
    GatedFeatName["ScreenshareAnnotations"] = "ScreenshareAnnotations";
    GatedFeatName["UnthrottledSubscribe"] = "UnthrottledSubscribe";
    GatedFeatName["DesktopSetMinimumWindowSize"] = "DesktopSetMinimumWindowSize";
    GatedFeatName["Onboarding2024"] = "Onboarding2024";
    GatedFeatName["ParticipantPanelPerf"] = "ParticipantPanelPerf";
    GatedFeatName["ChatV2Mentions"] = "ChatV2Mentions";
    GatedFeatName["ChatV2Reactions"] = "ChatV2Reactions";
    GatedFeatName["ChatV2OfflineDms"] = "ChatV2OfflineDms";
    GatedFeatName["MobileGuestCheckIn"] = "MobileGuestCheckIn";
    GatedFeatName["DesktopAutoFocusScreenshareWindow"] = "DesktopAutoFocusScreenshareWindow";
    GatedFeatName["VideoTileEmoteStream"] = "VideoTileEmoteStream";
    GatedFeatName["DesktopMiniModeAnimatedTransition"] = "DesktopMiniModeAnimatedTransition";
    GatedFeatName["DesktopEnableContextMenu"] = "DesktopEnableContextMenu";
    GatedFeatName["NewMeetingUXNoReactSpring"] = "NewMeetingUXNoReactSpring";
    GatedFeatName["CpuLimitationFewerVideos"] = "CpuLimitationFewerVideos";
    GatedFeatName["EnableScreenShareNetworkQualityIndicator"] = "EnableScreenShareNetworkQualityIndicator";
    GatedFeatName["AmbientAudioFiltering"] = "AmbientAudioFiltering";
    GatedFeatName["AmbientAudioFilteringWithResonance"] = "AmbientAudioFilteringWithResonance";
    GatedFeatName["StopOutOfMapRangeObjectsLoading"] = "StopOutOfMapRangeObjectsLoading";
    GatedFeatName["EnableCloudflareTurn"] = "EnableCloudflareTurn";
    GatedFeatName["PreferCloudflareTurn"] = "PreferCloudflareTurn";
    GatedFeatName["EnableTwilioTurn"] = "EnableTwilioTurn";
    GatedFeatName["DesktopInc461FocusDebugging"] = "DesktopInc461FocusDebugging";
    GatedFeatName["DesktopInc461FocusMitigations"] = "DesktopInc461FocusMitigations";
    GatedFeatName["DesktopInc461RemoveBrowserViewOnTransition"] = "DesktopInc461RemoveBrowserViewOnTransition";
    GatedFeatName["ForceReenableKrisp"] = "ForceReenableKrisp";
    GatedFeatName["DesktopScreenshareUseSystemPickerV2"] = "DesktopScreenshareUseSystemPickerV2";
    GatedFeatName["AvAiFeaturesInSettings"] = "AvAiFeaturesInSettings";
    GatedFeatName["DesktopDisableMediaFoundationVideoCapture"] = "DesktopDisableMediaFoundationVideoCapture";
    GatedFeatName["NetworkChangedListener"] = "NetworkChangedListener";
    GatedFeatName["KrispNative"] = "KrispNative";
    GatedFeatName["AmbientAudioWithProcessingSingleton"] = "AmbientAudioWithProcessingSingleton";
})(GatedFeatName || (exports.GatedFeatName = GatedFeatName = {}));
const getGatedFeatNameEnum = () => GatedFeatName;
exports.getGatedFeatNameEnum = getGatedFeatNameEnum;
const GATHER_OFFICE = "oxrhEtb3sV7VutbQ\\GatherOffice";
const PILOT_SSO_OFFICES = [
    GATHER_OFFICE,
    "S1DABUaEFIi5cch9\\Gather Dev General Space",
    "IwHMfgSdfKpl620G\\Test",
    "xXquUihc78ioSEPN\\HomeDepot SSO Test Space",
    "Jtr3HjR0qv3cxD5N\\doyensec-testing",
    "owRELZSP7maboGlS\\Holaluz",
    "AUWt24xnRhjKyCH3\\SundayAppSSOStagingTest",
    "dfjtyRxoSHNN6Jgx\\Stone Co 01",
    "6GB3fuw8d4H6QNmS\\Stone Co 02",
    "sxjBOKwQNNs5BTUt\\IAM",
    "CAcOj5aJIAXV9omH\\IAM2",
    "fMpGJBc0JM3z6fKw\\Stone Co 01 - HOMOLOG",
    "HmoQJC6XkQtMOdRr\\Stone Co 02 - HOMOLOG",
    "hhym8jsqfNsY5MvR\\ubh3",
    "mW4QHwNEKoFIGPyH\\ProbablyMonsters",
    "kGkbb0W1YrT9O2j8\\BigHat Engineering",
    "Vsikft6T1zukCoY1\\layerx",
    "aS8YA2UcWXJWvSBQ\\PayFit",
    "ZACiTgZLbkry3Ua4\\novata",
    "P6hMU1to6iF9nQrR\\HavenDigital",
    "e9W2fIi13CUA7You\\LegalZoom",
    "8MVgK93awQ1rWRlQ\\GSK",
    "cMrZ10a4zEX7VGg1\\HD",
    "yXt5hFRJ8tFqMSA4\\Duo - RD",
    "lm0a2s74474utmcZ\\MTL_digital_platform",
    "SsnFcSNvQEDHSA4d\\courtyard office",
    "RcRkACw6mOHJEfne\\Ford",
    "Fuey7WUhhQhkXykp\\Recruitics",
    "Sqz5qjT32Jy5wAHu\\springfield",
    "BHg4b9HrnuaYsrtY\\CloudRadial",
    "PAAJdRg1VR1aTBpf\\Sunrun",
    "MqyCJTubReivDCTE\\screenconnect",
    "h5FaosZx0nEtPtYt\\Base",
    "peMUc55BzsaV3WWo\\PlatinumGames",
    "N0SHfWMVjBXsphKy\\h2gs",
    "eLi9ytXe65e3cTHB\\Datasite",
    "Sax1DGytkQeGcRtr\\Segment Infrastructure",
    "X8PmUssqQrJshqhI\\prevision-produto-e-tech",
    "HS8JNCLnjniJGz89\\moonlite",
    "1YN0N9yIn6qVW1md\\Innovation",
    "EhL5LyldsqghwNnn\\Whitepages",
    "J1HgRjQ23phAv5Zs\\Second Dinner",
    "LX9K5oyS3I619tus\\Freed",
    "NNyvxnd7x1HUCMSE\\mercadolibretestSSO",
    "E8iySRNTOKlKoMqA\\Limbheim",
    "u8px4iaIl0hyWVAR\\Dispel Office",
    "EOJncXZfjUQCgS6q\\meli-test-sso",
    "MNtmFF33xOdMkslI\\Linear",
    "YzkPYEZxBlXwXPub\\mews-sa",
    "Vsikft6T1zukCoY1\\layerx",
    "pUoDt9HVLZCoQur1\\headspace",
];
const AVATARFLEET_OFFICE = "yaOaVzD38R3b4Acq\\avatarfleet";
const LEAKY_DESK_OFFICES = [
    "yaOaVzD38R3b4Acq\\avatarfleet",
    "RP9NdhXE2WGTnUl0\\realizingprogress",
    "nmxBIYUpoh3AfH25\\Data Cube Office",
    "zepmT9nHQyhhXQ1u\\S4F",
];
const TEXT_TOOLS_V2_OFFICES = [
    "3snKscmLNGBWOTa4\\Cloud Lyka",
    "P6hMU1to6iF9nQrR\\HavenDigital",
    "etggxvxl9h2Lq5Im\\KomponentWorks_Office",
    "O5MRcyagcF8P8nrk\\CoWork",
    "mxJlE0uKz6VNmutc\\text tools v2",
];
const GATHER_LABS_AMBIENT_OFFICES = [
    ...remoteWorkAmbientDeskTemplateSpaces_1.RW_AMBIENT_DESK_TEMPLATES,
    ...remoteWorkAmbientDeskTemplateSpaces_1.RW_AMBIENT_DESK_DRAFT_TEMPLATES,
];
const ANNOTATIONS_BETA_OFFICES = [
    "FnFtOnxrNMxMwWSx\\cjteam",
    "v5QCJAwFzqzeS8pc\\Enterprise Enablement",
    "AjepzwuzAzDJqIZX\\Lynton Skyscraper",
    "e9W2fIi13CUA7You\\LegalZoom",
    "jGhQWospeCgK3rrv\\datasite",
    "kjX2BHoYOr00Wv8E\\CausalHQ",
    "WZQiQ4iu2Q2LCfSR\\Syngenta Digital",
    "Fuey7WUhhQhkXykp\\Recruitics",
];
const INC_461_USERS_TO_TEST = [
    "plUSzqpEraUkhek8IoCPoqgYOJx1",
    "jozosd49RJWNbhO9mAykyuitmwD3",
    "GTPN7sdmr6P5VmsaBBO4u7Xg3RS2",
    "Qv8KTlW6AZNSCg3UjNJT0vad7Rc2",
    "J6EIE60hxMQpo7w1Erg0fFLq3Ok1",
    "0vHF5HNFnWS8n0r0jM1nF2TMig62",
];
const MEETING_SUMMARIZATION_WHITELIST = [
    "oxrhEtb3sV7VutbQ\\GatherOffice",
    "FVq0OsJF5EHisHua\\NestorPlayground",
    "rTH9FQnxAqadQYiN\\trustlayer",
    "YdDz9z6m3Db9i5kL\\Sensoria",
    "5ydqwSLaXy4HuHWN\\Fonsecantero",
    "DwFpGuy0tAY9OPf6\\futureisnow",
    "EEG293NWXCKOwdjV\\Alloggio",
    "xwIhbxW5sYHuUCfK\\burstingsilver",
    "kko8u1xagLueBdcj\\Heroic",
    "hOCd3IyZGVdu8EUe\\mybundle",
    "6bl8PtbGoTwmpaUj\\ExaApp",
    "Kx4RW2amn6AeM3IV\\spacetime",
    "QhmItymaZAuT8pRn\\AdInMo Remote Office",
    "k4hxrKixhWgqxGoo\\Dougs",
    "IWXgC2czPTW7x1X2\\sensay",
    "s8F6HPu3myrxWmYs\\Flash Pack HQ",
    "Zza4I4moTzkTOUus\\beatport",
    "XD2e8jbuwDcV4Fxx\\3dpc",
    "S2qysrWvO4w6n5qE\\seadster",
    "rrrZE3gcL775zVH4\\Priorities Test Room",
    "KJtZTMGZokoubJoK\\precise",
    "hS66ODyo46BRY45R\\appirits_DE-Ga",
    "HatPflsuO9jpVtcA\\virtualcraft",
    "fvvUxIRVLHzUbrA0\\BAQUA",
    "KfHiW0LkkI2k1q0G\\common",
    "Yyf8HGJA291Mtrah\\Mindset Courtyard",
    "mRU6Gdw89oWzjtXx\\roumu-center",
    "j20OoNXAEnshYglf\\digitalstarten",
    "sQknr4Zem5ZoSAvU\\dev-faume",
    "5nXUTh3A0kNMAK0l\\Tempest Labs",
    "IDdnjUzuHZYQICFk\\visionaryceoacademy",
    "RC5oJZqz8lAiegZv\\Strelo",
    "nKihkAhdEUxSxgyU\\Fluna",
    "afr6jKT1cohpeOyd\\aurelio-ai",
    "OPllUCPT7cbuvF8g\\alanda",
    "gkexZmNK1L3fuSwX\\mentoraai",
    "4P3uzmShMtNeWfyC\\Tech4Log",
    "o6Z8rFcIBiTTQpgf\\Laborit",
    "u0tNYl2vmoWouLcR\\Yes-Technology",
    "LX9K5oyS3I619tus\\Freed",
    "1K19D0OPkt9ry6OQ\\yavendio",
    "yePEsKs6cOUtKe6F\\EQUIPO POKEMON",
    "Z6dfd8ZDgPjkSJoW\\itsdecorably",
    "VDtBAqF1gIYHJN5I\\Baam Town",
    "3WXVLUSCweQClFsC\\MustFintech",
    "WvLdLHDKivd27pFQ\\Dkatalis",
    "QBT89mIiS0IsIYqB\\gg",
    "ppXPkxsj6cQanjwv\\lempire",
    "g2qCtxcLxeqQvoyN\\secfix",
    "XeWpMVE5UxSrWOCp\\CapLink",
    "nmxBIYUpoh3AfH25\\Data Cube Office",
    "ANXGOmg6vZdtwLFU\\radarblock",
    "BaRaOvQxuzREEljX\\SilliS",
    "I8sKChd3zlxN8bli\\OneQode",
    "jCrMcuX5wcf8h5Dj\\fooddash",
    "f9UBVCfEUMteYjLT\\palan-inc",
    "JRpPEhmvwsNwNY68\\DTC Pages World",
    "iD7D56WbBc3N0JNS\\Nstock HQ",
    "ZOFENFIbDjT1Lrgq\\sakurainternetrc",
    "KX08tEdl0KLzpvLx\\APEX Advocacy",
    "00hudc6turymCKTP\\FX",
    "opYLrvU5o4LdMbOA\\GiG",
    "bq7UUfIl6yCjd7s0\\Bulanco",
    "tDQyA3Ykcr69cEZW\\rarajob_office",
    "leCPq1K488WZJ9ug\\tebe",
    "jvwnZdRYV0eV8YXq\\elea",
    "ayclilhGAOferJEP\\sherpany",
    "eHqmRw1xWeuKLXnc\\newtr01",
    "raYrb2SVfvtRrFUJ\\Seqone",
    "g2BTIjPenaifkhJP\\biller",
    "Tla53NewdaOgG7ln\\teale-tech",
    "x7JlxTNscwoFtzKO\\Abersoft Office",
    "ZxTCHGgb6kpftGS6\\otark",
    "4YUocaIwqKqphnba\\Zaapi",
    "j3N7LWyikT7TqPXh\\MageBinary",
    "HAzdQTVpYt96Ns6I\\Calcme",
    "12BfCAKJpRBv7Row\\Spire Labs",
    "9U4VMVyEcABzqkD1\\tipspace",
    "h01nUDa2YmkeJn8t\\Kirana Labs",
    "eUfopurA5lbLV4vP\\Shuru",
    "27r2Ep77aZvEup8q\\adornis",
    "kGkbb0W1YrT9O2j8\\BigHat Engineering",
    "ceovuWhESqtSUWkt\\diydesignediting-HQ",
    "uZ27usqYKcpUOGOo\\crea_ce",
    "WfBhWbxQgXtt9kHs\\Specialsitter Office 3",
    "dLM7MUat73kMoX3T\\La Tribu",
    "UOkpBJC5c5b6W7OG\\Immofacile",
    "kSRNOyGoc2rFdZFh\\NN Product Office",
    "XbhGf1OfIhIPBpgM\\Doccla",
    "vBOZjxSaTBTihy5K\\Developer Working Area",
    "Iohjr4dNIAUQsyTw\\edugo",
    "DYvWcRvmicLILcv5\\REDSPARK",
    "zpIycC6oSyxLtTn2\\NetworktoCode",
    "4dXc4uU5gscfDrXx\\La Oficina HL",
    "hZWVx9yJwVETRtp6\\ZRO BANK - OFICIAL",
    "o9TMAQ6wlmfuw52g\\EARTHBRAIN",
    "yLAffPfvzUUwH9XW\\Dozle Corp",
    "I1a9HMxWpYso6Bpi\\ChildFundS4D",
    "6oaZORKVgksRVo3P\\Fluffy Dog",
    "V2jaN2G4OONrtnOm\\Rogers Hollow",
    "VlLZvDR5l56HChF2\\Agro1",
    "BeJbtpgSu07BA2Rl\\teamculture",
    "pC09UU5Q4Hnw9AgE\\Human-I-T",
    "XqbEDEKaXQyEju3x\\DaaS - inSuit - T2B - T4A",
    "Oc0BtSdzEITiZwN8\\MR4",
    "TBa6bbNdyp8GhtrX\\Team 4MDG",
    "GyFcYHyxucQLEW2s\\Hexabase",
    "LGjjkh5HhJ2gX29A\\Grupo 2biz",
    "qE12M6hyrfizMUze\\Auto republic",
    "DoblCppOoOfN7Tym\\CDO-TPIT",
    "gOuYeWjAXJyIGaNm\\EVARO",
    "hhym8jsqfNsY5MvR\\ubh3",
    "NxWRfFpi0hbgfgHR\\C-Controll",
    "PbyJNJY1Zets96LG\\Knose HQ",
    "dYhpfrnliKFTXGkI\\ohmyteeth",
    "wyPP1rNHSFQw6uHk\\PSTVirtualOffice1",
    "oiZp6OnQZKD7RX51\\Wooting World",
    "XXYewoHZSWgysgTS\\vOffice",
    "B8xhG57p1tp2mHz2\\Triptease Prod Eng 1",
    "6DsHHg1id4NTNPrU\\ateliware HQ",
    "4l8ZD7N0dGHiIcOB\\Blacksheep Team",
    "6QiuZ1xtD9d37y10\\Filament Games",
    "tzeDL3yzBDEGzzTB\\RegLife",
    "UnQOIUo2ehN62TEU\\Roots Town",
    "YMaJl5yPq8Nols5W\\Evaneos",
    "00dlysYmSzR4qHNM\\Nuuvem",
    "HaoVuj1z3VLlkO5E\\Bizapp",
    "6dO5e6kvCclWqGpD\\srconsulting",
    "tcY58swQpzYhcAm0\\Circulo CRM",
    "XNlvrLc3N9RlAH48\\dotworld",
    "dCjApB2ypE1hRGdm\\2Stallions Virtual Office",
    "krQmkKyGdgj2cxTL\\Catalys",
    "L9FJpjhlUCIpFVRG\\agenciahiro",
    "oFQKOMTj5kDx6z7a\\Allied Insight",
    "SqvV3u9TQQfkjyLj\\monicle-group",
    "OLrp5ZyXIfLsv2Ve\\THINKY",
    "GkkmDJPPY2c7mcd4\\Kravata",
    "mdWrBn9Sb7oac48q\\Experience Office",
    "2JCuE9LTjWjTWqX4\\northius",
    "j3zi58mZ1R9SQ8vT\\booost",
    "zuv1gJfzVEeREaR2\\gibobs",
    "jyqMBMnjrJtDZNSo\\Morpheus Tecnologia",
    "PQwBkXD5rO3Cgp8j\\Kickbase",
    "16B7LH6VHvWNKH08\\datametrix",
    "4GEpisqCRpb86gpQ\\FR8LABS",
    "gPEicb8A8VE00Ed1\\Poli",
    "M1XW1sgFLqhOWF1C\\ledger-investing",
    "OOF5sFPWwcVVWdD4\\mindflow",
    "PQNJeV9xU8ZPBBnG\\eCommerce Today",
    "rreH4aNrPCwUATCK\\rooser-hq",
    "x4MMT4GeC2HOddFm\\Vhg Hub",
    "DbfH8W8HrklDCCgK\\thirdweb",
    "UcQoUTfCTpoCasUe\\ClimateCamp",
    "0Qk5HeeRWObODCYJ\\Assistencial",
    "3H9GN8DNoa8raJsy\\FrogwellVOffice",
    "FGWaiFYwUkAVTj8q\\comodoplanejados",
    "Id8e6JpbIB2EaZgv\\Smart Home",
    "jHedYg2gZW2F40g5\\SensorUp",
    "JawxD3K1jCcGiuvJ\\Grapdes",
    "Pez0lPoI1XvaQhTn\\whaticket",
    "F7euKNwqvE5EBGMr\\ZCO",
    "FPCVoIBdDO6n5dvz\\yampaverso",
    "n4ZoJSXiFhCqgIwW\\flowie",
    "4BQ8I0MBMIq9KdKu\\MicroHabitat",
    "4o1g9b5SnFXQZh3n\\Genero Virtual Office",
    "N8qA7Akp1EkyteBV\\Gecko",
    "W4AlJXJGW6PqE8Ql\\foxsolution",
    "DtBKQni5K6iljyFS\\replicate",
    "X3otgCQahgyWgtJp\\H2G WORLD",
    "Kb0O8sR6Z4CBWOrQ\\cmu",
    "p0blL1vnEX3NMvb3\\octant",
    "RQvLOHnVmuI7Bkw1\\Flowers-Software",
    "zaFUGmfquLh3U77T\\rapaydo_office",
    "0sASHZXXQ5aKuHds\\ADAPTEAD",
    "bxiwdaBC0GatBHN8\\syrup",
    "mlH0pcJ6QZKhH59G\\shoplab",
    "7GFdSw6E4VHcFR1q\\SmartInnovation",
    "f1fnXoyJhLejTjir\\lockerinthecity",
    "LSqSGtnenrSg6cf4\\advolve-ai",
    "g9wHc48NHuSQgDh0\\Ficha",
    "bAPhjM5NER0CbHla\\AdHoc",
    "LjoMqvjJFbG7rATV\\Wanteeeam",
    "880ZOw1OW37oiPbR\\Marcel Digital",
    "GEmYcj7mLum9VhtW\\starshot",
    "jossqfkGloNG9cSM\\Cloudify",
    "Org15p8SZ1awPaBa\\Elyzio",
    "VYkntiyB7nY2TOUh\\SimpleTalk AI",
    "GNvM9TYwqQFjkBUa\\Averroes",
    "jD6Oyk4rEZVNs0bx\\steakhouse",
    "5agxQK4RjDnEzgoo\\sml-dev-team",
    "aYcuxMm9QNk8fZ0K\\STH-2",
    "rxuCPRYRHp3XPm0Y\\Sena Arquitetura",
    "sDdAYZcMpZYS6Yqf\\Genetica",
    "1LVIdZKXbqVnIt5P\\misstipsi",
    "UbEO0ujpHHFbygP1\\Routific",
    "4BH3mzqhJqv48mz1\\Sage Networks",
    "fiHPMahMoX2vK96E\\Ausha",
    "G2NC1uWQPq0nWXOu\\onacy",
    "iw7n2hT0dAyzJUpu\\kingpanda",
    "LjvTDT16i2LxAssx\\Mapit",
    "MIDcYD8ByFEDrpHJ\\Crisis Text Line",
    "PSg37PCo1kkXSIIe\\fanfix",
    "VojHfOcJEzELQss6\\gatezero",
    "VyvfVtBpajDopm4y\\Airbag HQ",
    "wjxhnPqbp70OlRm9\\tophatch_hq",
    "1PH9TZ114YlLaJk1\\ol",
    "FLYPyIZDQRROeDbB\\arvolution",
    "wLKaFlJmTIF02Iz3\\momentslab",
    "yaOaVzD38R3b4Acq\\avatarfleet",
    "2zBOhCxMN6aKqm5B\\codenato",
    "6TkCNIPInqKILwX5\\bigcatstudio",
    "8QFh6LY82rfWOXQg\\HelemClub",
    "HOq7LCU5lwdWHbXL\\elearniodev",
    "IAdDKkMvgRu43l1B\\Halotherapy Solutions",
    "MfqkGQUKH7wjFrXI\\catalog",
    "P8qoxtOmRrNSlZ96\\Saltear",
    "vpIToIx7ZcAcT1It\\Mission-io",
    "WgMdqrNskWBuyT3j\\infleet",
    "X9u1LwjWqzZLD9ws\\Smartown",
    "2r2gX22COnd64on4\\DepoIQ",
    "CGnZI5vjPOtjKqKp\\Prime",
    "EgSZgrkwFUY3WCxC\\AuraSide",
    "fpgfTD9FLJ9JyXR6\\Beanstalk Growth",
    "G55v8g6lc4Z0O7h6\\GPTZero Team",
    "GtB0W6fqaFq7Mo7A\\28b",
    "pK7gOQsHmCgfYZ6w\\qraneos",
    "QEsyYpWXHJiSqh08\\Grupo ADNG",
    "sxuZAPyUQQkmUfLo\\crescent",
    "tAFPpRhlBDjGAauj\\Simify",
    "uwdaBjxTH2R4wX89\\spacerockgames",
    "xMg7NqX2hN6imkZp\\chikaku",
    "YiHtBsGfifSWjbBj\\cocolomi",
    "1QGODz8c3b89SIqS\\zigguratum",
    "c2RkKD9GCMU86reS\\jsocitspace",
    "fnkAr0dJK3EsK20b\\Aterlo",
    "0BzLiwNKOv8U1B4z\\La Forge",
    "awv2HMfbkSMMwHIs\\trinio",
    "BHg4b9HrnuaYsrtY\\CloudRadial",
    "oNmzSIetRLi8ZtQe\\retreatguru",
    "rMkjsqPy0tIJZkOh\\Montre",
    "Rnu0ERfrNjt5kRWZ\\Carrot",
    "ZWR5tPpAEBgF7sgf\\Novu Office",
    "8mEYYWSY4ADa9Ajn\\onlydust",
    "9S8xNdX6SF591hUu\\Ernesti",
    "DlJbgpCbgRrnRf5v\\SJ-Consulting",
    "IxsHel1kcn9AyJMK\\Pixel8Labs",
    "kbPEAl7ZSo597z8n\\Blox",
    "LgrhgajgMf9MYS28\\FCA HQ",
    "OWkIhbptEJdQ5eZ0\\Morphosis Blocks HQ",
    "PSIizxjXzFVz74yS\\omnichat",
    "vodN37PgIfks4nhB\\Lorenzsoft",
    "2A2iDTW9oFb3DKtN\\Brandcast Health Hub",
    "3ctXBd3rK0XzARLA\\Wambeach Off",
    "9m2O1t0eaC7rqTWQ\\Levr",
    "BpV8BuVt2rEJpUqY\\aiir-office",
    "lSTc3QTFxfqB4FEi\\mutherboard",
    "MEb8bGkcTKqOM636\\Rednil Brokers",
    "VzGZXhFUazGBRqBs\\Hyerdesk",
    "wdOMqOwIWp2lBP0m\\FMH Thailand",
    "YYo5jEhiUMk5mv0I\\reviseradiology",
    "086PcB7AHrgaNW4l\\CIXON",
    "5CswfELmGh8GEQQ5\\inflead",
    "6J4xz4p1qFlwvmR9\\Multidrop",
    "cD19kBYdy7Gc8iTF\\E4 Beta",
    "dfcoIHaY5KAonuJQ\\Meeko",
    "lU4nG3NpUkGH1FqK\\neynar",
    "O95AnCpDKRdhb38F\\jalan",
    "udWbdv0k91Yi4Ndi\\happypaltech",
    "VKFwnKBqlfcLYN7J\\Teamwerx",
    "Yfeo2QvNsVRtWdZK\\bentoml",
    "7sdkchIh2VAnYdas\\MEC",
    "B5KEzKawWemENAG3\\Truss Office",
    "F5A1sTzcqDCOdQI6\\Sunny Lab",
    "SJ3qKz6sb7RQ7IW9\\bytefine",
    "SYyDoiFTpwi8f85w\\visible",
    "wGk0xstrnlC3ekBq\\matsuri-dev",
    "xD0t9B96xlFaezJM\\RoboSource",
    "EYFxpo9jhEOgjpao\\RightTouch",
    "hEqg1whEyBI42gqx\\Cleo",
    "om3cdSpDStGfAL65\\agest_cto_room",
    "S3ObDS3tkFTzuGK6\\BlackjackFun",
    "z3OwQDSyS5XmUKAr\\desk-ly Remote HQ",
    "z8fyomtrBMsvhIPy\\endvr",
    "2MJrbn6TVEgF1pMi\\susu",
    "Agg6zLXUlO3PXC0g\\Discovery One",
    "bGZv5cFLWtZlJnWA\\Estoko",
    "c7crRtguBdasmx5I\\DreamShaper",
    "DNey22oDcToaf5Z6\\P4U",
    "KGgx2AOTUawqPBFK\\InnovaOffice",
    "MZthvbaUvSjS2tGl\\afua",
    "QUFNId7LE808VzTo\\breakout-learning",
    "XKPaT09D7cSdXA2W\\guidanceanalytics",
    "nqZXg36gcmtaic0W\\forelogic",
    "yujBS5Bf7u2ucv4l\\CoreUs",
    "4l1IYgfmfsIHHiws\\AptaAI",
    "QwvZHig9Kwbw2TLh\\vistasocial",
    "5rEuvICBKE38Wr0Z\\Defense Unicorns",
    "cnYxpm2dMQ0oUZP2\\useallsoftware",
    "c3majpp5afanSrbQ\\inCall Systems",
    "2y55AzuRkomeVSxk\\happyrobot",
    "r1BZgQiIkF9k9z25\\Grafana-k6",
    "JOvZYS1WhtBKmTL4\\NeuesBuero",
    "qaNURFVBRhmVypBu\\Vector Office",
    "whJDY1vxpEvLrcBP\\Awarefy",
    "0c4wnQ9RLgSnZTAB\\olivai",
    "fPOhYVHnBTgwBc8j\\MetaNest III",
    "4hMX6Sq2obHVMph3\\monoverse",
    "m5UqybVLl1KttCij\\office",
    "dCShhKcumFpvtt16\\macall",
    "qOGDHDTdZL5TSD3v\\ISS Office",
    "565KYCn4t0rYIBL4\\nflabs-rd",
    "1qTafaNQyWjvnMzy\\OSEA Innovations",
    "dSVAHsTwGUrNWUoC\\NE Digital",
    "Cum5PDMczDx4stm1\\IW Hangar 2",
    "HcQ4VhtJLjdfCyqw\\reddy",
    "OJHZGrpVfNH8ZQ4L\\Rubicon",
    "Q8uUUNz2eUyFZlCy\\RIIICO-HQ",
    "umqKmd7TstTHKx7m\\Hulampro - cozy",
    "CrkqwNewitglAdg8\\MakiSpace",
    "RMnaXNKfSoRGmcGz\\Socialabs",
    "C2Ukm2efThlBPkas\\intuition",
    "d8wetWgzwn3ydx8V\\madeformed",
    "JEUdctLB7n82HTzS\\bluemeg",
    "jVGIjMmqzKPZ8BEf\\Reva",
    "leJxANUAB5JArV5F\\Typewise Virtual Office",
    "LUiY8iKhkVWoeBa0\\Advize Solutions",
    "Ro42omJVjyusxmXO\\matter",
    "NSqyou03Phmtf5AN\\Dashgoo",
    "URhkOgeN8Zp6KNv9\\Finest Solutions",
    "zifaH5yf4pWSd2nX\\ommaworks",
    "2EgBp6X90hHMkZOj\\ZEALOT",
    "Cum5PDMczDx4stm1\\IW Hangar 2",
    "KtNeUaUSWbQM2ZcB\\TradeLink Townhall",
    "qydZ63b3IQYxAIXm\\Tivit TDX",
    "i2Lu2vapvbMnPLZL\\Gametime HQ",
    "cEuUtmRgcBiejzgU\\SquatchHQ",
    "c5t4Gme3LOYkDFK6\\elemnta-virtual-office",
    "QYUfetC0lvUcBhZg\\OiDreamTeam",
    "aYR316ngA585SjYT\\LunaEdge",
];
const FEATURES = {
    [GatedFeatName.SpaceAATest1]: {
        exposure: 0.5,
        space: true,
    },
    [GatedFeatName.SpaceAATest2]: {
        exposure: 0.5,
        space: true,
    },
    [GatedFeatName.SpaceAATest3]: {
        exposure: 0.5,
        space: true,
    },
    [GatedFeatName.UserAATest1]: {
        exposure: 0.5,
        space: false,
    },
    [GatedFeatName.UserAATest2]: {
        exposure: 0.5,
        space: false,
    },
    [GatedFeatName.UserAATest3]: {
        exposure: 0.5,
        space: false,
    },
    [GatedFeatName.WallsAndFloors]: {
        exposure: 0,
        space: true,
        whitelist: [
            "oJ6hrCfIPu0iUoSr\\123",
            "C44J0PiDMaX2a1va\\Fair Design Draft2",
            "jktHKn1FC3yTarGG\\SAF",
            "vBeHQxkRCm0oQJWP\\Dukgo-gwan",
            "XBHaN6ao99FaGLR9\\LES3EscapeRoomTemplate",
            "e6HViX1i6J66ZXfZ\\Giants Pitch Roulette",
            "dSeLpaCYaGuKjL3Q\\DeepRecreation",
            "skRjep6YgjG52iWw\\Cyberdyne",
            "cWj4lpy5RwVH5GYU\\shoe",
            "lKb73t5XgicBj36NTest_Lampp",
            "q8VELgSo5ZxUxAfe\\Tribo de Dados",
            "tWnfS5ssxBVqWssB\\Chapter 4",
            "vlIHaXpAgI8xUY6b\\auravant",
            "k9CDyOPPbjNz8xSZ\\The Playground",
            "fxB8higfLGo5QVIm\\Rekk Metaverso",
            "aKxmNqpjGp5ZhcWP\\Techne Open Evening",
            "fto7cmASwHoI9PcL\\GE_GatherSpace",
        ],
        enableOnLocalEnv: false,
        enableForBeta: true,
    },
    [GatedFeatName.LeakyPrivateSpace]: {
        space: true,
        exposure: 0,
        whitelist: [GATHER_OFFICE, ...LEAKY_DESK_OFFICES, ...GATHER_LABS_AMBIENT_OFFICES],
        enableOnLocalEnv: true,
        enableForBeta: true,
        notifyOutdatedClients: true,
    },
    [GatedFeatName.LeakyDeskUI]: {
        space: false,
        exposure: 0,
        whitelist: [GATHER_OFFICE, ...LEAKY_DESK_OFFICES, ...GATHER_LABS_AMBIENT_OFFICES],
        enableOnLocalEnv: false,
        enableForBeta: true,
        notifyOutdatedClients: true,
    },
    [GatedFeatName.LeakyDeskUIPhysics]: {
        space: false,
        exposure: 0,
        whitelist: [],
        enableOnLocalEnv: false,
    },
    [GatedFeatName.LeakyDeskListeningRangeUI]: {
        space: false,
        exposure: 0,
        whitelist: [],
        enableOnLocalEnv: false,
    },
    [GatedFeatName.LeakyDeskListeningRangeUINoVideos]: {
        space: false,
        exposure: 0,
        whitelist: [],
        enableOnLocalEnv: false,
    },
    [GatedFeatName.LeakyDeskFocusOverBusy]: {
        space: true,
        exposure: 0,
        enableOnLocalEnv: false,
        whitelist: [
            GATHER_OFFICE,
            ...GATHER_LABS_AMBIENT_OFFICES,
            "RP9NdhXE2WGTnUl0\\realizingprogress",
        ],
        enableForBeta: true,
        notifyOutdatedClients: true,
    },
    [GatedFeatName.LeakyDeskPods_DEPRECATED]: {
        space: true,
        exposure: 0,
        enableOnLocalEnv: false,
        whitelist: [GATHER_OFFICE, ...LEAKY_DESK_OFFICES],
        notifyOutdatedClients: true,
    },
    [GatedFeatName.LeakyDeskPodsExpanded]: {
        space: true,
        exposure: 0,
        enableOnLocalEnv: false,
        whitelist: [AVATARFLEET_OFFICE, "RP9NdhXE2WGTnUl0\\realizingprogress"],
        notifyOutdatedClients: true,
    },
    [GatedFeatName.LeakyDeskOpenCoworking]: {
        space: false,
        exposure: 0,
        whitelist: [GATHER_OFFICE, ...GATHER_LABS_AMBIENT_OFFICES],
        enableOnLocalEnv: false,
        enableForBeta: true,
    },
    [GatedFeatName.LeakyDeskDeskPods]: {
        space: true,
        exposure: 0,
        whitelist: [GATHER_OFFICE, ...GATHER_LABS_AMBIENT_OFFICES],
        enableOnLocalEnv: false,
        enableForBeta: true,
    },
    [GatedFeatName.LeakyDeskSideConversations]: {
        space: true,
        exposure: 0,
        whitelist: [],
        enableOnLocalEnv: false,
        enableForBeta: true,
    },
    [GatedFeatName.LeakyDeskAmbientVolumeSlider]: {
        space: true,
        exposure: 0,
        whitelist: [GATHER_OFFICE],
        enableOnLocalEnv: false,
    },
    [GatedFeatName.LeakyDeskAmbientFeedbackModal]: {
        space: true,
        exposure: 0,
        whitelist: [GATHER_OFFICE],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.CenteredNavBar]: {
        space: true,
        exposure: 0,
        enableOnLocalEnv: false,
    },
    [GatedFeatName.InventoryV2]: {
        space: true,
        exposure: 0,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.GardenTown]: {
        space: true,
        exposure: 0,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.RemoteLogsEnabled]: {
        space: true,
        exposure: 0,
        enableOnLocalEnv: true,
        whitelist: [
            GATHER_OFFICE,
            "yNVArfxmAVZKfDfT\\loadtest3",
            "RHKKO3g6hkFsDukn\\FTAPI",
            "nInQPOxJERxKmx2G\\Office 1",
        ],
    },
    [GatedFeatName.ScreenRecording]: {
        space: true,
        enableOnLocalEnv: true,
        exposure: 1,
        whitelist: [
            GATHER_OFFICE,
            "WgJKfrcMufN10eBW\\new rw-36",
            "vsZUvSC6UGdzUwMd\\MR QA",
            "hRAr9tEfulnhNMZv\\rec",
            "90mWQoFCNtWYusys\\rec-test",
            "invGxutjn1i3w0Pm\\P I T A",
            "AG9RAYlColA4wpKB\\aliveworkshop",
            "vFtpScR79xJ1GZGq\\Pedreira Topazio",
            "HGG3UGdboTvemVWS\\Keiron",
            "DxPvQzHphM87Jjlu\\intraversa",
            "l75IqatVC8j8KvlP\\Application Team",
            "IRIOC5Sw6r9kPh0L\\ZetaChain",
            "vodN37PgIfks4nhB\\Lorenzsoft",
            "4ZvWetPlQC59ARXe\\Chain Team",
            "i0sdw8JAqCHFw0xS\\LetsMOD",
            "NdBuojBWHeR4vsRc\\Printi",
            "ZBNapGJx6oloEJ7a\\TechUpClassroom",
            "qemL7awtTR7j7TaC\\ProdEng",
            "R893tJu4Z3o8cQbn\\leadtracker",
            "w5Mggo7WSt5Ingk1\\uncork-it",
            "Yvj4Y7YmLawyrOQv\\RITE",
            "9pLKxLWFiDEdme1u\\TRS-CAT-Officespace",
            "OSqw5ojvc31pXYEy\\weme",
            "tLt4aPfFygY7Yjem\\Vinta",
            "DcuwqnArSD5dZSJW\\ClearChoiceSystem",
            "G4syimQc0Gml3o6B\\visitgradient",
            "I5kZBSnBRBF4Ffmz\\singlifeph",
            "P0ReSpDkhW5IHCTj\\breuninger-dpm",
            "7836o0SMPkR9ATb0\\LaunchGood",
            "q73nX8vYYSJSkFqA\\gonimbly-pilot1",
            "etggxvxl9h2Lq5Im\\KomponentWorks_Office",
            "9Y9OVeybPXd7LjRi\\Nexl Global HQ",
            "50o3rCV9opXS4hzi\\metaexpo",
            "fdpc1UiadpZNyQBP\\EPIC_Digitais",
            "XHJMpcZfop3j9qUl\\SPACEMAKERS",
            "qxE6OGS7qV9d9luf\\gamifygatherhq",
            "WCDrXYpNeQDhld3t\\ReuniVous Office",
            "rOyxaSNfaWoBAmHL\\Gathletics",
            "Le3FVu8WKXX8TemQ\\TRS-Support-Office",
            "eeIvwe8cTOCrVPjU\\LightshipOffice",
            "uBirJOQK0WzhERFc\\zig-zag",
            "0LLuftuHj6gMyB8W\\designstripe 2023",
            "16DnzM3B692Gnadz\\TheReady_Office",
            "XHJMpcZfop3j9qUl\\SPACEMAKERS",
            "XPzifdIhavfWswKd\\pydepypermarketing",
            "r4X5GaegbLRGfWCJ\\Eqlosion",
            "3NEScr8iE7skwSVo\\eduteam",
            "7ScNpZnKQ8JIcSQ3\\Semantix SDP A",
            "KtNeUaUSWbQM2ZcB\\TradeLink Townhall",
            "kRJT0bxPvmJ2pf1I\\Bundy Ranch",
            "cphPebiafQVRSmIW\\BTPHeadquarters",
            "NWAzHWz6W8WGEMvL\\CognitiveSpaceStation",
            "0sASHZXXQ5aKuHds\\ADAPTEAD",
            "g29wJ4LKu4aqBwah\\plusjam2023",
            "1ARLWsaPtcttphVw\\OMOW",
            "hr8JGVPtXIewJ5Lc\\devgames_2023",
            "oocX0rKlYnsctfl5\\Hub Vive Sano",
            "9HHQRIYoUyCm3qCC\\cto-remote",
            "6mVPWgZKkDajBJ3E\\Semantix Metaverse",
            "krQmkKyGdgj2cxTL\\Catalys",
            "u2KiW9LXfV4Ij9Tm\\Joy Valley",
            "Df6FIJM5fXhre3GH\\weposh",
            "G2vrTimm5Zz1HGMd\\Clints Lobby",
            "FEUyGrPtcPmKafS4\\Eqlosia",
            "zGMjxhTzv1cWgMPE\\RBL",
            "x5Xz9P6njvr7pVLc\\synthesis",
            "Quu2DL7x7gIYUxP8\\CaptivateIQ",
            "O5MRcyagcF8P8nrk\\CoWork",
            "VU9RJcVge6gfxbLo\\Storyblocks",
            "FEUyGrPtcPmKafS4\\Eqlosia",
            "VRy0WWt8DAcWvGGa\\Gather Builder Studio",
            "AjepzwuzAzDJqIZX\\Lynton Skyscraper",
            "4JATDvki0nUma9bE\\Nx",
            "5rEuvICBKE38Wr0Z\\Defense Unicorns",
            "Tf2hjNBW293nENju\\GP_VERSO",
            "rTH9FQnxAqadQYiN\\trustlayer",
            "rq7nZLQQVFwlRWb7\\playback",
            "sxuZAPyUQQkmUfLo\\crescent",
            "cEuUtmRgcBiejzgU\\SquatchHQ",
            "nInQPOxJERxKmx2G\\Office 1",
            "QojFJ1TznLVH54D0\\theFinanceStack",
            "TWXcA97pjnHeSKaD\\Photocreate",
            "aBpG6TQtco0UeW15\\thepixelshop",
            "ly4pyQsmOpw2YZtJ\\voyage",
            "sL2shRSHJVxb2Bmy\\Hajimari Works",
            "RP9NdhXE2WGTnUl0\\realizingprogress",
            "BpV8BuVt2rEJpUqY\\aiir-office",
            "wjxhnPqbp70OlRm9\\tophatch_hq",
            "bTGfZAtc4RPHJP47\\AGIL fx",
            "z2WXhUCKs7Dyqj18\\Sesimi",
            "qkpzMEReMi7ODLxp\\protofy",
            "uKC7JUYy8TiYJkDu\\HeroDevs HQ",
            "O6teSt7Sx032YmvE\\nilo",
            "1sfJ8oTZn0GF8x4h\\attractions-io",
            "WvLdLHDKivd27pFQ\\Dkatalis",
            "0YQhF8KTFt4yi66N\\Finch",
            "vybZXEgnCki7cdRU\\hallow-product",
            "1c3uB2McKgOkBuuz\\Osol",
            "W4AlJXJGW6PqE8Ql\\foxsolution",
            "rvs9oIhTK2bzWYZG\\bakuraku",
            "3snKscmLNGBWOTa4\\Cloud Lyka",
            "ZACiTgZLbkry3Ua4\\novata",
            "rsVYRJ4RIC5loTgV\\1inch-dapp",
            "VDtBAqF1gIYHJN5I\\Baam Town",
            "Ufvjmv6VYcsWTpgS\\imBee",
            "Rm25hDr0Kr8gKWxd\\CTO Labs Event Space",
            "at9ttKlDhGmiWrpF\\Unamint Labs",
            "4exxD59wXiLPq4yH\\Capevo",
            "ALtFzJaYA68zMEu6\\nightschool",
            "P6hMU1to6iF9nQrR\\HavenDigital",
            "UcQoUTfCTpoCasUe\\ClimateCamp",
            "5yfB4xgOLvkboBeS\\Debutify Main Office",
            "yMyVUd5OXrFWw9Il\\Casa dos Voxuyers",
            "wDd1a3kWHwlSdF3u\\CAGECE - GETIC",
            "YYO1JD7wrf6wonJn\\xmart-2308",
            "LtO8fHc7H8UlLJho\\Platform Team",
            "P6hMU1to6iF9nQrR\\HavenDigital",
            "EGIYC2KocoXps8B2\\Brightside",
            "Q8uUUNz2eUyFZlCy\\RIIICO-HQ",
            "XbhGf1OfIhIPBpgM\\Doccla",
            "Kb0O8sR6Z4CBWOrQ\\cmu",
            "aWOlCG5DaYvjGZP2\\latitude",
            "kjX2BHoYOr00Wv8E\\CausalHQ",
            "S5opuzgIsWmB5Rkm\\SPACE_MAKERS",
            "BiVQKw8AKJSkNnjk\\hypar",
            "EFbDwfG12FvJWJM6\\Base Eng Buildathon",
            "JysaEzXymmdkOr2T\\corespace",
            "880ZOw1OW37oiPbR\\Marcel Digital",
            "kUB9unD1TjNhY2hR\\adventurefamilytravel",
            "nh0cwHN9ZKM45BhC\\navifyanywhere2",
            "w4ts3PzwZlyjE5MP\\VideoAsk",
            "0Qk5HeeRWObODCYJ\\Assistencial",
            "Naz72pJnCafsyYwv\\l2beat",
            "yCmDyLt4s3LpKyLi\\nvsl",
            "yaOaVzD38R3b4Acq\\avatarfleet",
            "Vsikft6T1zukCoY1\\layerx",
        ],
    },
    [GatedFeatName.GatherAvHoldout]: {
        exposure: 0.1 / 0.9,
        space: true,
        enableOnLocalEnv: false,
        whitelist: [],
    },
    [GatedFeatName.EnableWebGL2]: {
        exposure: 0,
        space: false,
        enableOnLocalEnv: false,
    },
    [GatedFeatName.AcceleratedStartup2]: {
        exposure: 1.0,
        space: true,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.DesktopPreviewReleases]: {
        exposure: 0,
        space: true,
        enableOnLocalEnv: false,
        whitelist: [],
    },
    [GatedFeatName.TestABTestingAndMetricsUser]: {
        exposure: 0.25,
        space: false,
        enableOnLocalEnv: true,
        whitelist: [],
    },
    [GatedFeatName.TestABTestingAndMetricsSpace]: {
        exposure: 0.25,
        space: true,
        enableOnLocalEnv: true,
        whitelist: [],
    },
    [GatedFeatName.ShowGameClientStatus]: {
        exposure: 0.5,
        space: true,
        enableOnLocalEnv: true,
    },
    [GatedFeatName.ScreenShareBorderMac]: {
        exposure: 1,
        space: false,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.ScreenShareBorderWin]: {
        exposure: 1,
        space: false,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.FetchProcessNames]: {
        exposure: 0,
        space: false,
        enableOnLocalEnv: true,
        whitelist: [],
    },
    [GatedFeatName.Bunnies]: {
        exposure: 0,
        space: true,
        enableOnLocalEnv: true,
        whitelist: [],
    },
    [GatedFeatName.DynamicLocalVideoQuality]: {
        exposure: 0,
        space: false,
        enableOnLocalEnv: false,
        whitelist: [],
    },
    [GatedFeatName.SSOAuthentication]: {
        exposure: 0,
        space: true,
        enableOnLocalEnv: false,
        whitelist: PILOT_SSO_OFFICES,
    },
    [GatedFeatName.DevicePixelRatioForAdaptiveStream]: {
        space: true,
        exposure: 0,
        enableOnLocalEnv: true,
        whitelist: [],
    },
    [GatedFeatName.MobilePushNotifications]: {
        space: true,
        exposure: 0,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.ReloadSfuOnDoubleConnect]: {
        space: true,
        exposure: 0.25,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.UpscaledGather]: {
        space: true,
        exposure: 0,
        enableOnLocalEnv: false,
    },
    [GatedFeatName.PerfSurvey]: {
        space: true,
        exposure: 1,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.LeakyDeskBackgroundSFX]: {
        space: true,
        exposure: 0,
        enableOnLocalEnv: false,
        whitelist: [GATHER_OFFICE, "yL9ahQI2cCzUBPwl\\e-frogg v2"],
    },
    [GatedFeatName.PresentStatus]: {
        space: true,
        exposure: 0,
        enableOnLocalEnv: false,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.NewTextTool]: {
        space: true,
        exposure: 1,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE, ...TEXT_TOOLS_V2_OFFICES],
    },
    [GatedFeatName.PortalsImprovements]: {
        space: true,
        exposure: 1,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.ScreenshareLowerResolution]: {
        space: false,
        exposure: 0,
        enableOnLocalEnv: false,
        whitelist: [
            "BGwLj7crsWV4kZ8p\\LHH",
            "lM8n4MNiTQG0RamO\\LHHBranches",
            "KtNeUaUSWbQM2ZcB\\TradeLink Townhall",
            "dfjtyRxoSHNN6Jgx\\Stone Co 01",
            "6GB3fuw8d4H6QNmS\\Stone Co 02",
        ],
    },
    [GatedFeatName.PromoteToMember]: {
        space: true,
        exposure: 1,
    },
    [GatedFeatName.AudioRevokeObjectUrl]: {
        space: false,
        exposure: 0.5,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.DesktopRendererANRDetection]: {
        space: false,
        exposure: 0,
        enableOnLocalEnv: false,
        whitelist: [
            GATHER_OFFICE,
            "VjbpAhTMmerPuU9V\\Departamento de TI",
        ],
    },
    [GatedFeatName.DesktopThrottleUpdateCheckWhenOffline]: {
        space: false,
        exposure: 0,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.OrganicDesktopAutoUpdates]: {
        space: false,
        blacklist: [GATHER_OFFICE],
        exposure: 1.0,
        enableOnLocalEnv: true,
    },
    [GatedFeatName.DesktopUseGETForUpdateCheck]: {
        space: false,
        exposure: 0.0,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.NewVirtualBgImages]: {
        space: false,
        exposure: 0.5,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE, "ZP2q4hoBBftgA46P\\clazar_office"],
    },
    [GatedFeatName.GatherStudio]: {
        space: true,
        exposure: 0,
        enableOnLocalEnv: true,
        whitelist: [
            GATHER_OFFICE,
            "YyaHyT2wICh674oD912DSIyD6tq1",
            "m5SXvlTD1NN6YvLzFmglE79SyMC3",
            "7XLTubWgKH5LJXF6\\Desk 2017",
        ],
    },
    [GatedFeatName.HideSelfView]: {
        space: true,
        exposure: 1,
        enableOnLocalEnv: false,
    },
    [GatedFeatName.ShowGatherLabsNewChatFeature]: {
        space: true,
        exposure: 0,
        enableOnLocalEnv: true,
        whitelist: [
            GATHER_OFFICE,
            "w5Mggo7WSt5Ingk1\\uncork-it",
            "OpapZD0zSi0ABTno\\Sendbird",
            "BqYsdDx7WMFdDFo7\\sendbirdcs",
            "S5opuzgIsWmB5Rkm\\SPACE_MAKERS",
            "qxE6OGS7qV9d9luf\\gamifygatherhq",
            "etggxvxl9h2Lq5Im\\KomponentWorks_Office",
            "TSWJsfaYj5MRiLGp\\infinitethread-dreamspace",
            "rOyxaSNfaWoBAmHL\\Gathletics",
            "yl9Hhd8RkJeXyNFY\\Bigle",
            "3snKscmLNGBWOTa4\\Cloud Lyka",
            "DcuwqnArSD5dZSJW\\ClearChoiceSystem",
            "aWOlCG5DaYvjGZP2\\latitude",
            "O3EiYjLynjkC4JNM\\datastreamer",
            "VU9RJcVge6gfxbLo\\Storyblocks",
            "nInQPOxJERxKmx2G\\Office 1",
            "gNINPyxi3Xzj0k4R\\toucan",
            "RP9NdhXE2WGTnUl0\\realizingprogress",
            "NwZ6WXg3Kv6uOAHB\\jsnordic",
        ],
    },
    [GatedFeatName.DesktopAutoRestart]: {
        space: false,
        exposure: 1.0,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.UseElectronForRecordingDownloads]: {
        space: true,
        exposure: 0.0,
        enableOnLocalEnv: true,
    },
    [GatedFeatName.WhatsNewNotification]: {
        space: false,
        exposure: 1,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.ParticipantsPanelV2]: {
        space: true,
        exposure: 1,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.SendbirdVerboseLogLevel]: {
        space: true,
        exposure: 0,
        whitelist: [GATHER_OFFICE],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.MobileVideoSubscriptions]: {
        space: true,
        exposure: 0,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE, "pvcWpCAtAijVu65Z\\GATHER-BOTS-DON"],
    },
    [GatedFeatName.ScreenShareZoom]: {
        space: true,
        exposure: 1.0,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.PaymentsAnnualPlan]: {
        space: true,
        exposure: 1,
        whitelist: [],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.NoisyEnvironmentDetection]: {
        space: true,
        exposure: 0,
        whitelist: [GATHER_OFFICE],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.Insights]: {
        space: true,
        exposure: 1,
        whitelist: [
            GATHER_OFFICE,
            "NdBuojBWHeR4vsRc\\Printi",
            "BGwLj7crsWV4kZ8p\\LHH",
            "hVgZm7ld6oep40Ch\\3BR TECH",
            "oO7oD8wHqE1bMF6r\\bAV Digital",
            "0YQhF8KTFt4yi66N\\Finch",
            "P6hMU1to6iF9nQrR\\HavenDigital",
            "cEuUtmRgcBiejzgU\\SquatchHQ",
            "yXt5hFRJ8tFqMSA4\\Duo - RD",
            "FDlR6hKzvfePR4U6\\multiplica",
            "w5Mggo7WSt5Ingk1\\uncork-it",
            "tLt4aPfFygY7Yjem\\Vinta",
            "AOncte5mX4lchK25\\Virtual Office",
            "NwZ6WXg3Kv6uOAHB\\jsnordic",
            "nInQPOxJERxKmx2G\\Office 1",
            "etggxvxl9h2Lq5Im\\KomponentWorks_Office",
            "VU9RJcVge6gfxbLo\\Storyblocks",
            "xWprJ8GqFIRfdkpR\\mews",
            "O5MRcyagcF8P8nrk\\CoWork",
            "DcuwqnArSD5dZSJW\\ClearChoiceSystem",
            "3snKscmLNGBWOTa4\\Cloud Lyka",
        ],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.MiniModeNavBarButton]: {
        space: true,
        exposure: 0,
        whitelist: [GATHER_OFFICE],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.ChooseSfuByScoring]: {
        space: true,
        exposure: 1.0,
        whitelist: [GATHER_OFFICE],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.MiniModeV2]: {
        space: true,
        exposure: 1,
        whitelist: [GATHER_OFFICE],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.LocateButtonOnParticipantsPanel]: {
        space: false,
        exposure: 1,
        enableOnLocalEnv: true,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.DesktopCliDisableCalulateNativeWinOcclusion]: {
        space: false,
        exposure: 1.0,
        whitelist: [
            GATHER_OFFICE,
            "tLplwgsXCRZ7k4d5E7teHKatTtk2",
            "mm36pBXU1iN4urmudFdLRqT9CrB3",
        ],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.DesktopCliUseMultiPlaneFormatForSoftwareVideo]: {
        space: false,
        exposure: 0,
        whitelist: [
            "PQrrNIcstNRjPUoEHtI0rfIHfc52",
            "4Ut4njDiNqbStv8QxUC8TFX6NoH3",
            GATHER_OFFICE,
        ],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.DesktopCliEnableScreenCaptureKitMac13]: {
        space: false,
        exposure: 0,
        whitelist: [],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.DesktopCliEnableScreenCaptureKitMac14]: {
        space: false,
        exposure: 0,
        enableOnLocalEnv: true,
        whitelist: [],
    },
    [GatedFeatName.DesktopCliEnableAllowWgcWindowCapturer]: {
        space: false,
        exposure: 0,
        whitelist: [
            "YzkPYEZxBlXwXPub\\mews-sa",
            "DYvWcRvmicLILcv5\\REDSPARK",
            "bcvl0llsg6MGGww2IXNrQk27k3v2",
            "JI6Zfh3TqZe8KHfevsvIXXGcuix1",
            "p8GUxF2sy1b7N6j9TGKUmZDGG9p2",
            "iazJd0RUyeTEXVW7PGHkdQ7bB6m1",
            "CiaGCIDoEXboTK4165QHeJuQBnS2",
            GATHER_OFFICE,
        ],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.EnhancedBNRUseBVC]: {
        space: true,
        exposure: 0.5,
        whitelist: [GATHER_OFFICE, "BGwLj7crsWV4kZ8p\\LHH", "lM8n4MNiTQG0RamO\\LHHBranches"],
        blacklist: ["nInQPOxJERxKmx2G\\Office 1", "8wFawAMaWSMbbtHZ\\IT-Tech Workspace"],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.DesktopAutoUpdateFromDownloadsGatherTown]: {
        space: false,
        exposure: 0,
        whitelist: [GATHER_OFFICE, "BGwLj7crsWV4kZ8p\\LHH", "lM8n4MNiTQG0RamO\\LHHBranches"],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.LiveCursors]: {
        space: true,
        exposure: 0.1,
        whitelist: [GATHER_OFFICE],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.ReportUnexpectedActiveSpeaking]: {
        space: false,
        exposure: 0.001,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.VideoServerStats]: {
        space: false,
        exposure: 1,
        enableOnLocalEnv: true,
    },
    [GatedFeatName.NewPricingModel]: {
        space: true,
        exposure: 0,
        whitelist: [],
        enableOnLocalEnv: false,
    },
    [GatedFeatName.DesktopCliEnableAllowWgcScreenCapturer]: {
        space: false,
        exposure: 0,
        whitelist: [
            "YzkPYEZxBlXwXPub\\mews-sa",
            "DYvWcRvmicLILcv5\\REDSPARK",
            "bcvl0llsg6MGGww2IXNrQk27k3v2",
            "DwERrwRp9YnqLvaS\\Playstack",
            "p8GUxF2sy1b7N6j9TGKUmZDGG9p2",
            "iazJd0RUyeTEXVW7PGHkdQ7bB6m1",
            "CiaGCIDoEXboTK4165QHeJuQBnS2",
            GATHER_OFFICE,
        ],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.DesktopDisableWindowTransitionFix]: {
        space: false,
        exposure: 0.0,
        whitelist: [],
        blacklist: [
            ...INC_461_USERS_TO_TEST,
            "BUids58YBdXihvNDg55LReTmwmm1",
            "TfBNSb5iLQZxFTAEfbBmdLN2Vof2",
            GATHER_OFFICE,
        ],
        enableOnLocalEnv: false,
    },
    [GatedFeatName.VirtualBackgroundsNoConcurrencyCheck]: {
        space: false,
        exposure: 1,
        whitelist: [
            GATHER_OFFICE,
            "CWC82d3MbyOwdpbXamG5R0RdgBg1",
            "SqX8jFHk1jcQbgBxf6dmFPq0q7l2",
            "8fGywj4yebYYeOYSKJVnRkIjqc62",
            "QejXq5L1HCaqah5Zrkm1wVCs0mB3",
            "OGhBER7IEzOfU6RD3ZSNSdDOYzG2",
            "2xSevoHKfxeNx71EDdUZ1Xiz7x02",
            "8Eo0fpmCp0VCy7DYtul7l2UOjZF3",
        ],
    },
    [GatedFeatName.PauseMoveControllerDuringSwitchMap]: {
        space: false,
        exposure: 0.1,
        whitelist: [
            GATHER_OFFICE,
            "nInQPOxJERxKmx2G\\Office 1",
            "BGwLj7crsWV4kZ8p\\LHH",
            "51bQsptSz8dTaJz7\\rewst",
        ],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.DesktopUseHigherResIconsForScreenShareModal]: {
        space: false,
        exposure: 0.5,
        whitelist: [GATHER_OFFICE],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.NewMeetingUX]: {
        space: true,
        exposure: 1.0,
        whitelist: [
            GATHER_OFFICE,
            "e9W2fIi13CUA7You\\LegalZoom",
            "v5QCJAwFzqzeS8pc\\Enterprise Enablement",
            "Sax1DGytkQeGcRtr\\Segment Infrastructure",
            "dbSmSJiWMs49k6pt\\GATHER-BOTS-BryanNMUX",
            "OOF5sFPWwcVVWdD4\\mindflow",
            "Naz72pJnCafsyYwv\\l2beat",
            "wNLDnm0Xw19ZjaaF\\deepr",
            ...ANNOTATIONS_BETA_OFFICES,
        ],
        blacklist: [
            "NYHTk3mJkLOiU9vkXoZivxfWVD12",
            "BffxE4wzNeXWTm76EermsGYt4V33",
            "YzkPYEZxBlXwXPub\\mews-sa",
            "nInQPOxJERxKmx2G\\Office 1",
            "NwZ6WXg3Kv6uOAHB\\jsnordic",
            "c6KHaTUNS913Gumq\\Vobi2024",
            "N16q3DTM8NBALRy7\\GATHER-BOTS-BryanOMUX",
            "2sYpJY7zdWXbjSf8Wu4kbGH2TNn1",
            "pBJAOU059pncYtp4\\brainspace",
            "cMrZ10a4zEX7VGg1\\HD",
            "bIib9V25ByZw7gPE\\SmartDataNanalytics",
            "PKNFXUUp4YdO0CJztTwOcaEEsa23",
            "m5gShgWf1NQGhr2Lu9I8kyzWo9B3",
            "dfjtyRxoSHNN6Jgx\\Stone Co 01",
            "6GB3fuw8d4H6QNmS\\Stone Co 02",
        ],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.NoVideoAnimations]: {
        space: false,
        exposure: 0,
        whitelist: [],
    },
    [GatedFeatName.NoVideoAnimationsAllHardware]: {
        space: false,
        exposure: 0.1,
        whitelist: [
            "OOF5sFPWwcVVWdD4\\mindflow",
            "Naz72pJnCafsyYwv\\l2beat",
            "bIib9V25ByZw7gPE\\SmartDataNanalytics",
            "wNLDnm0Xw19ZjaaF\\deepr",
            "YzkPYEZxBlXwXPub\\mews-sa",
            "aMzs8DZLvwXo4fcmcsAdmY6jVGA3",
            "O3EiYjLynjkC4JNM\\datastreamer",
        ],
    },
    [GatedFeatName.DesktopFailedUpdateNotification]: {
        space: true,
        exposure: 1.0,
        blacklist: [
            "BGwLj7crsWV4kZ8p\\LHH",
            "lM8n4MNiTQG0RamO\\LHHBranches",
            GATHER_OFFICE,
        ],
    },
    [GatedFeatName.UnthrottledSubscribe]: {
        space: false,
        exposure: 1,
        enableOnLocalEnv: true,
        whitelist: [
            GATHER_OFFICE,
            "T3gPyfCfBsW4JreP\\GATHER-BOTS-quan-test",
            "WOJMo7MwTUxrtv46\\GATHER-BOTS-quan-test",
        ],
    },
    [GatedFeatName.ScreenshareAnnotations]: {
        space: true,
        exposure: 1,
        whitelist: [GATHER_OFFICE, ...ANNOTATIONS_BETA_OFFICES],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.PlayerShimmy]: {
        space: true,
        exposure: 0,
        whitelist: [
            GATHER_OFFICE,
            "JJUu3baR48kVGsVn\\test001",
        ],
        enableOnLocalEnv: false,
    },
    [GatedFeatName.DesktopSetMinimumWindowSize]: {
        space: false,
        exposure: 1.0,
        whitelist: [GATHER_OFFICE],
    },
    [GatedFeatName.MobileGuestCheckIn]: {
        space: true,
        exposure: 1,
        whitelist: [
            GATHER_OFFICE,
            "dKOwXy5DZgAsonpK\\Test1",
        ],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.Onboarding2024]: {
        space: true,
        exposure: 1.0,
        blacklist: [
            "dbSmSJiWMs49k6pt\\GATHER-BOTS-BryanNMUX",
            "N16q3DTM8NBALRy7\\GATHER-BOTS-BryanOMUX",
        ],
        enableOnLocalEnv: false,
    },
    [GatedFeatName.ParticipantPanelPerf]: {
        space: false,
        exposure: 0.5,
        enableOnLocalEnv: false,
        whitelist: [],
    },
    [GatedFeatName.ChatV2Mentions]: {
        space: true,
        exposure: 1.0,
        whitelist: ["YlZFg1lO7CRUqEqN\\jul3 mentions test", GATHER_OFFICE],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.ChatV2Reactions]: {
        space: true,
        exposure: 1.0,
        whitelist: ["q6zE6Gxy8vj9hG73\\jul3 reactions test", GATHER_OFFICE],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.ChatV2OfflineDms]: {
        space: true,
        exposure: 1.0,
        whitelist: ["I9EGPYAGZ7YUGUCY\\joao-office-prod", GATHER_OFFICE],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.DesktopAutoFocusScreenshareWindow]: {
        space: false,
        exposure: 1.0,
        whitelist: [],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.VideoTileEmoteStream]: {
        space: false,
        exposure: 0.5,
        whitelist: [GATHER_OFFICE],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.DesktopMiniModeAnimatedTransition]: {
        space: false,
        exposure: 0,
        whitelist: [],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.DesktopEnableContextMenu]: {
        space: false,
        exposure: 1.0,
        whitelist: [GATHER_OFFICE],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.NewMeetingUXNoReactSpring]: {
        space: false,
        exposure: 0.1,
        whitelist: [],
        enableOnLocalEnv: false,
    },
    [GatedFeatName.CpuLimitationFewerVideos]: {
        space: false,
        exposure: 0,
        whitelist: [],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.EnableScreenShareNetworkQualityIndicator]: {
        space: false,
        exposure: 0,
        whitelist: [GATHER_OFFICE],
        enableOnLocalEnv: false,
    },
    [GatedFeatName.AmbientAudioFiltering]: {
        space: false,
        exposure: 0,
        whitelist: [GATHER_OFFICE],
        enableOnLocalEnv: false,
    },
    [GatedFeatName.AmbientAudioFilteringWithResonance]: {
        space: false,
        exposure: 0,
        whitelist: [GATHER_OFFICE],
        enableOnLocalEnv: false,
    },
    [GatedFeatName.StopOutOfMapRangeObjectsLoading]: {
        space: false,
        exposure: 0,
        whitelist: [
            "e8LKFBXxF8SdTwEe9SWbkPjGEVm1",
            GATHER_OFFICE,
            "ih77joTjcI16mrWq\\PB Marketing Digital",
            "51bQsptSz8dTaJz7\\rewst",
            "NdBuojBWHeR4vsRc\\Printi",
            "RHKKO3g6hkFsDukn\\FTAPI",
            "w05Z9AYixi16UuZF\bugcrowd001",
        ],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.EnableCloudflareTurn]: {
        space: false,
        exposure: 1,
        whitelist: [GATHER_OFFICE],
        blacklist: [],
        enableOnLocalEnv: false,
    },
    [GatedFeatName.PreferCloudflareTurn]: {
        space: true,
        exposure: 1,
        whitelist: [GATHER_OFFICE],
        enableOnLocalEnv: false,
    },
    [GatedFeatName.EnableTwilioTurn]: {
        space: true,
        exposure: 0,
        whitelist: [
            "cMrZ10a4zEX7VGg1\\HD",
        ],
        enableOnLocalEnv: false,
    },
    [GatedFeatName.DesktopInc461FocusDebugging]: {
        space: false,
        exposure: 1.0,
        whitelist: [...INC_461_USERS_TO_TEST, GATHER_OFFICE],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.DesktopInc461FocusMitigations]: {
        space: false,
        exposure: 0,
        whitelist: [...INC_461_USERS_TO_TEST, GATHER_OFFICE],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.DesktopInc461RemoveBrowserViewOnTransition]: {
        space: false,
        exposure: 1.0,
        whitelist: [...INC_461_USERS_TO_TEST, GATHER_OFFICE],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.DesktopScreenshareUseSystemPickerV2]: {
        space: true,
        exposure: 1.0,
        whitelist: [
            "tsQMQ7u0X8ZcEtYuvvqrAXYRwMt2",
            "lCLSlr181tXjKG2TxqEJLmF9Kjv2",
            "WBHFBtVvvvca9n0oOzEYFduqNS53",
            "a1dbXl8yMCVNnc10T10xIUiMc2q1",
            "TfBNSb5iLQZxFTAEfbBmdLN2Vof2",
            "FTLEzpvGl5e09Y1cU3MmYNDi7bk2",
            "2NH38dayHNfHEIihNHWRBaGLG5Z2",
            "4BYPZ0PprrUdjNagkyDrNpuVGSy1",
            "4oFszP920uTosVS6MLqj58zzkMs1",
            "sCNmtohcELgWYPTAcgAWrmOYR6P2",
            "vBDNfvSVRJTuMSW28UNQnmmOXD42",
            "VAXnhFpPdcRnFwTsl4aiOAJECCs2",
            GATHER_OFFICE,
        ],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.DesktopDisableMediaFoundationVideoCapture]: {
        space: false,
        exposure: 0.0,
        whitelist: [
            "ZQ8Ignfz0yTltDP1cbnTzzSQIPX2",
            "6j6b8EBkBWh72LZExFGHHxnS0yH2",
            "sYsUWiy8tvZw2EcVDYrSnrdKwMK2",
        ],
        enableOnLocalEnv: false,
    },
    [GatedFeatName.ForceReenableKrisp]: {
        space: true,
        exposure: 1.0,
        whitelist: [],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.AvAiFeaturesInSettings]: {
        space: true,
        exposure: 0,
        whitelist: MEETING_SUMMARIZATION_WHITELIST,
        blacklist: [
            "cMrZ10a4zEX7VGg1\\HD",
            "CrTtd26ugm8W107O\\THDEngineerExperience",
            "AOncte5mX4lchK25\\Virtual Office",
            "Vupe06LJRXTWdLNC\\Protential",
            "g57rs9ekjhn6b0yX\\LHH Training Center",
            "JxBbLkJeJ2qas2yM\\Smith Market - HR-SCL-ENG",
            "lM8n4MNiTQG0RamO\\LHHBranches",
            "BGwLj7crsWV4kZ8p\\LHH",
            "4yUv27pM6A5xOCTn\\LZLS",
            "e9W2fIi13CUA7You\\LegalZoom",
            "dfjtyRxoSHNN6Jgx\\Stone Co 01",
            "6GB3fuw8d4H6QNmS\\Stone Co 02",
            "RcRkACw6mOHJEfne\\Ford",
            "aS8YA2UcWXJWvSBQ\\PayFit",
            "Vsikft6T1zukCoY1\\layerx",
            "oHGGhKfb85cC2xTR\\alpacatech",
            "PAAJdRg1VR1aTBpf\\Sunrun",
            "P6hMU1to6iF9nQrR\\HavenDigital",
            "nInQPOxJERxKmx2G\\Office 1",
            "EFbDwfG12FvJWJM6\\Base Eng Buildathon",
            "h5FaosZx0nEtPtYt\\Base",
            "mjLMgtK0t1orHunS\\GrupoBoticario",
            "NdBuojBWHeR4vsRc\\Printi",
            "pgZ83MO2i74vQRR6\\Totvs-InfraOps",
            "lDPlia2jOs7nfU0t\\TOTVS Fluig",
            "1YN0N9yIn6qVW1md\\Innovation",
            "VDnO9nIJ9kEWrhvK\\Hubspot",
        ],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.NetworkChangedListener]: {
        space: false,
        exposure: 0.0,
        whitelist: [
            "vrdvYPyfjGPtwUpGfUNxE1YzzLt2",
        ],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.KrispNative]: {
        space: false,
        exposure: 1.0,
        whitelist: [GATHER_OFFICE],
        enableOnLocalEnv: true,
    },
    [GatedFeatName.AmbientAudioWithProcessingSingleton]: {
        space: true,
        exposure: 0,
        whitelist: ["Ir5oLd3KX65dYmH2\\quanAA"],
        enableOnLocalEnv: true,
    },
};
const getFeatures = () => FEATURES;
exports.getFeatures = getFeatures;
exports.FEATURE_GATES_BUILT_FILE_NAME = "gates-manifest.json";
//# sourceMappingURL=FEATURES.js.map